import React,{useState,useEffect} from "react";
import { Link } from "react-router-dom";
import { FaThumbsUp } from "react-icons/fa6";
import { FaEye } from "react-icons/fa";
import classes from "./VideoGrid.module.css";
import { arr } from "../Data";
import {useSelector} from 'react-redux';
import axios from 'axios';
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

const VideoGrid = ({ videos }) => {

  const {lang} = useSelector((state)=>state.langSlice)

  const [imageLoad,setImageLoad] = useState(true);


  // const changeLang=(key)=>{
  //   // console.log(key)
  //   if(lang == 0){
  //     return key;
  //   }
  //   if(lang == 1){
  //     // console.log("====",key)
  //    const data = arr?.findIndex((item)=>item?.key == key);
  //   //  console.log(data)
  //    if(data>=0){
  //     return arr[data]?.value;
  //    }
     
  //   }
  // }

 

  const handleImageLoading=(src)=>{
    console.log('loading')
    setTimeout(()=>{
      setImageLoad(false);
    },1000)
      
  }


  useEffect(() => {
    const img = document.querySelector('img');
    if (img.complete) {
      handleImageLoading();
    } else {
      img.addEventListener('load', handleImageLoading);
      return () => {
        img.removeEventListener('load', handleImageLoading);
        // img.removeEventListener('error', handleImageError);
      };
    }
  }, []);



  console.log(imageLoad,'===');




  return (
    <div className="w-full grid grid-cols-4 max-[800px]:grid-cols-2 max-[1000px]:grid-cols-3 gap-4">
      {videos?.map((data) => {
        return (
          <div className={`w-full bg-white ${classes.shadow}`} key={data?.id}>
            <Link to={`/videos/${data?.id}`} className="w-full ">
              <div className="flex flex-col gap-0 h-full ">
                <div className="px-2 py-3 bg-black text-slate-200">
                  <div>
                    <p
                      className={`text-lg font-semibold max-[800px]:text-sm ${classes.truncate}`}
                    >
                      {/* {changeLang(data?.name)} */}
                      {data?.name}
                    </p>
                  </div>
                </div>
                  <div className="w-full h-full bg-black p-0 ">
                  {
                    !imageLoad ?
                  <img
                    src={data?.imageFiveUrl}
                    // src="https://media.istockphoto.com/id/615422436/photo/demo-sign-cubes.jpg?s=612x612&w=0&k=20&c=HHOLIiF8SmbIssxKv3G480EgTVub_v9cc1QME3Dn6XU="
                    alt={data?.name}
                    className="object-fill w-full h-[12rem]"
                    onLoad={handleImageLoading}
                  />
                  :<Skeleton baseColor="#202020" highlightColor="#444" className='h-[12rem] m-0 w-full'/>
                  
                   }
                </div>
               

                <div className="px-2 py-2 flex flex-row justify-between items-center">
                  <div className="flex flex-row justify-start gap-4">
                    <div className="flex flex-row gap-2 items-center">
                      <div>
                        <FaEye />
                      </div>
                      <h2>{data?.views}</h2>
                    </div>
                    <div className="flex flex-row gap-2 items-center">
                      <div>
                        <FaThumbsUp />
                      </div>
                      <h2>{data?.likes}</h2>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          </div>
        );
      })}
    </div>
  );
};

export default VideoGrid;
